<template>
  <div class="loader-container">
    <Quantities :quantities="quantities" />
    <Concessions
      v-if="
        quantities && (quantities.available > 0 || quantities.available == -1)
      "
      :product="product"
      :prices="prices"
      :basket-item-groups="basketItemGroups"
      :quantities="quantities"
      @add-to-basket="addToBasket"
    />
    <SeatPlan
      v-if="!!seatPlan && !!prices && !!quantities && quantities.available > 0"
      :seat-plan="seatPlan"
      :prices="prices"
      :basket-items="basketItems"
      @seat-click="seatClick"
    ></SeatPlan>
    <Loader
      :loading="
        !basket ||
          loadingPrices ||
          loadingSeatPlan ||
          loadingQuantities ||
          addingToBasket
      "
    />
  </div>
</template>
<script>
import Service from '@/services/Service.js';
import Concessions from '@/components/Concessions.vue';
import SeatPlan from '@/components/SeatPlan.vue';
import Loader from '@/components/Loader.vue';
import Quantities from '@/components/Quantities.vue';
import { mapState } from 'vuex';

export default {
  components: { Concessions, SeatPlan, Loader, Quantities },
  props: {
    product: { type: Object, default: null }
  },
  data: function() {
    return {
      prices: null,
      seatPlan: null,
      quantities: null,
      loadingPrices: false,
      loadingSeatPlan: false,
      loadingQuantities: false,
      addingToBasket: false
    };
  },
  computed: {
    basketItems() {
      return this.getBasketItems();
    },
    basketItemGroups() {
      return this.getBasketItemGroups();
    },
    ...mapState(['basket'])
  },
  created() {
    this.getPrices(this.product.id);
    this.getSeatPlan(this.product.id);
    this.getQuantities(this.product.id);
  },
  methods: {
    getBasketItemGroups() {
      return this.basket.itemGroups.filter(
        x => x.productId === this.product.id
      );
    },
    getBasketItems() {
      var vals = [];
      for (var i = 0; i < this.basketItemGroups.length; i++) {
        vals = vals.concat(this.basketItemGroups[i].items);
      }
      return vals;
    },
    getPrices(productId) {
      this.loadingPrices = true;
      Service.getPrices(productId).then(response => {
        this.prices = response.data;
        this.setQuantities();
        this.loadingPrices = false;
      });
    },
    getSeatPlan(productId) {
      this.loadingSeatPlan = true;
      Service.getSeatPlan(productId).then(response => {
        this.seatPlan = response.data;
        this.loadingSeatPlan = false;
      });
    },
    getQuantities(productId) {
      this.loadingQuantities = true;
      Service.getQuantities(productId).then(response => {
        this.quantities = response.data;
        this.loadingQuantities = false;
      });
    },
    setQuantities() {
      var self = this;
      if (self.prices && self.basketItemGroups) {
        //set the concession.quantities with the basketitem quantities
        self.prices.concessions.forEach(function(concession) {
          let basketItemGroups = self.basketItemGroups.filter(
            x => x.concessionId == concession.id
          );
          var quantity = 0;
          basketItemGroups.forEach(function(basketItemGroup) {
            if (basketItemGroup.quantity) {
              quantity = quantity + basketItemGroup.quantity;
            }
          });
          self.$set(concession, 'quantity', quantity);
        });
        this.quantitiesUpdated = true;
      }
    },
    seatClick(seatId) {
      this.addToBasketWithItem(seatId);
    },
    addToBasket() {
      this.addToBasketWithItem(null);
    },
    addToBasketWithItem(itemId) {
      this.addingToBasket = true;
      this.$store
        .dispatch('ensureSession')
        .then(() => {
          var basketitemGroups = [];
          this.prices.concessions.forEach(concession => {
            if (
              concession.quantity > 0 ||
              this.basketItemGroups.filter(x => x.concessionId == concession.id)
                .length > 0
            ) {
              var basketItemGroup = {};
              basketItemGroup.concessionId = concession.id;
              basketItemGroup.quantity = concession.quantity;
              basketItemGroup.productId = this.product.id;
              basketitemGroups.push(basketItemGroup);
            }
          });
          var basketRequest = {};
          basketRequest.itemGroups = basketitemGroups;
          basketRequest.itemId = itemId;
          Service.addToBasket(basketRequest)
            .then(() => {
              this.$store
                .dispatch('loadBasket')
                .then(() => {
                  this.setQuantities();
                  this.addingToBasket = false;
                  this.$store.dispatch('addMessage', {
                    message: 'Basket Updated',
                    timeout: 3000
                  });
                })
                .catch(error => {
                  this.addingToBasket = false;
                  this.$store.dispatch('addMessage', {
                    message: 'Error loading basket'
                  });
                  console.log(error);
                });
            })
            .catch(error => {
              switch (error.response.data.exceptionType) {
                case 'Monad.Data.OutOfStockException':
                  this.$store.dispatch('addMessage', {
                    message: 'Available Quantity Exceeded',
                    timeout: 3000
                  });
                  break;
                case 'Monad.Data.NotOnSaleException':
                  this.$store.dispatch('addMessage', {
                    message: 'Not On Sale',
                    timeout: 3000
                  });
                  break;
                case 'Monad.Data.ProductLimitException':
                  this.$store
                    .dispatch('loadBasket')
                    .then(() => {
                      this.setQuantities();
                      this.$store.dispatch('addMessage', {
                        message:
                          'Basket Updated. ' +
                          error.response.data.exceptionMessage,
                        timeout: 3000
                      });
                    })
                    .catch(error => {
                      this.$store.dispatch('addMessage', {
                        message: 'Error loading basket',
                        timeout: 3000
                      });
                      console.log(error);
                    });
                  break;
                default:
                  this.$store.dispatch('addMessage', {
                    message: 'Error adding to basket'
                  });
                  console.log(error);
              }
              this.addingToBasket = false;
              console.log(error.response);
            });
        })
        .catch(error => {
          this.addingToBasket = false;
          console.log(error.response);
        });
    }
  }
};
</script>
